import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/FooterTwo";
import Newsletter from "../components/Newsletter";
import FaqArea from "../components/FaqArea"; // O componente que acabamos de criar

const Faq = () => {
  let [active, setActive] = useState(true);
  useEffect(() => { setTimeout(function () { setActive(false); }, 500); }, []);
  
  return (
    <>
      <HelmetReact title={"Dúvidas Frequentes - Grupo Rocvel"} />
      <HeaderTwo />
      <Breadcrumb title="Dúvidas Frequentes" />
      <FaqArea />
      <FooterTwo />
    </>
  );
};

export default Faq;